import { Route, Routes } from "react-router-dom";
import { privateRoute, publicRoute } from "./pagesData";
import Menu from "components/Menu";
import { Flex } from "@chakra-ui/react";
import { Toaster } from "components/ui/toaster";
import { useSelector } from "react-redux";
import { httpClient } from "services/api/httpClient";
import { HeaderMain } from "components/HeaderMain";

const Router = () => {
  const userData = useSelector((state) => state.userData);

  const routesR = ({ data }) =>
    data.map(({ path, title, element }) => (
      <Route key={title} path={`/${path}`} element={element} />
    ));

  if (userData?.accesstoken) {
    httpClient.setAuthorization(userData?.accesstoken);
  }

  return (
    <Flex flex={1} h="100vh" w="100wh" direction={"column"} bg={'appbg.solid'}>
      <Toaster />
      <HeaderMain type="router" />
      <Flex flex={1} overflow={"hidden"}>
        <Menu type="router" />
        <Routes>
          {routesR({ data: userData?.active ? privateRoute : publicRoute })}
        </Routes>
      </Flex>
    </Flex>
  );
};

export default Router;
